import React, { useState } from "react";
import "./BulkDataPage.css";

const WhatsAppMarketingPage = () => {
  const [activeIndustry, setActiveIndustry] = useState("Retail");
  const [expandedFAQ, setExpandedFAQ] = useState("What is Bulk WhatsApp?");

  const industries = [
    {
      id: "retail",
      label: "Retail",
      description:
        "Notify customers about promotions, new product launches, and personalized offers.",
    },
    {
      id: "ecommerce",
      label: "E-commerce",
      description:
        "Facilitate seamless shopping experiences with order tracking and customer service.",
    },
    {
      id: "fintech",
      label: "Fintech",
      description:
        "Provide real-time transaction alerts, enhance security with two-factor authentication, and support consumer education.",
    },
    {
      id: "healthcare",
      label: "Healthcare",
      description:
        "Send appointment reminders, follow-up messages, and offer real-time patient support.",
    },
    {
      id: "travel",
      label: "Travel",
      description:
        "Share booking confirmations, itinerary updates, safety tips, and offer timely customer support.",
    },
  ];

  const faqs = [
    {
      question: "What is Bulk WhatsApp?",
      answer:
        "Bulk WhatsApp is our business messaging service that utilizes WhatsApp Cloud API, allowing businesses to send and receive messages.",
    },
    {
      question: "Can I send any kind of message?",
      answer:
        "You can send Text messages, Media messages, Documents, and Videos. Using Cloud API, you cannot participate in group chats.",
    },
    {
      question: "What do I need to get started?",
      answer: (
        <div>
          <p>i) Create a WhatsApp Business Account (WABA) on business.facebook.com</p>
          <p>
            ii) Link your WABA account with a mobile number (this mobile number
            should not have an existing WhatsApp account)
          </p>
          <p>
            iii) Verify your Business Portfolio (verification enables you to
            scale up your messaging limit)
          </p>
          <p>iv) Create Template Messages</p>
          <p>v) Send bulk messages on app.peakmobile.co.ke</p>
        </div>
      ),
    },
    {
      question: "What are Template Messages?",
      answer:
        "A message template is required to start a business-initiated conversation. These conversations can include customer care messages, appointment reminders, payment or shipping updates, alerts, and more.",
    },
    {
      question: "What is a Business-Initiated conversation?",
      answer:
        "Business-initiated conversations are conversations initiated by businesses outside the 24-hour messaging window. Businesses must use a Message Template to start a business-initiated conversation.",
    },
    {
      question: "What is a User-Initiated conversation?",
      answer:
        "User-initiated conversations are conversations initiated by customers. Businesses will be charged user-initiated conversation fees when they reply to messages within the 24-hour messaging window.",
    },
    {
      question: "Can I use my existing WhatsApp number?",
      answer:
        "Yes, you can use an existing WhatsApp number for Bulk WhatsApp. However, you will need to first delete the account currently linked to that number.",
    },
    {
      question: "Are there any limits to the number of messages I can send using your platform?",
      answer:
        "WhatsApp limits the number of messages you can send based on a tier system. Every new account starts at Tier 1 – 2,000 after passing the business verification process. You are automatically upgraded to the next tier based on the volume and quality of the messages you send.",
    },
    {
      question: "What do you mean by the quality of messages?",
      answer:
        "These are business-initiated messages that follow WhatsApp guidelines, are sent to the target customer, and include clear opt-out procedures.",
    },
    {
      question: "Can WhatsApp penalize me for sending low-quality messages?",
      answer:
        "Yes, WhatsApp can downgrade your limit tiers if more of your messages are reported or blocked by users. We advise you to send only approved templates and avoid sending repeated messages.",
    },
    {
      question: "What are the charges?",
      answer: (
        <div>
          <p>
            You pay a monthly platform access fee of <strong>Ksh 4,000</strong>,
            billed quarterly.
          </p>
          <p>
            Any message you send will be billed as per WhatsApp API’s
            conversation-based fees:
          </p>
          <p>
            <strong>Marketing:</strong> $0.0225 / Ksh 2.9
          </p>
          <p>
            <strong>Authentication:</strong> $0.004 / Ksh 0.52
          </p>
          <p>
            <strong>Utility:</strong> $0.004 / Ksh 0.52
          </p>
        </div>
      ),
    },
  ];

  const toggleFAQ = (question) => {
    setExpandedFAQ(expandedFAQ === question ? null : question);
  };

  return (
    <div className="bulk-data-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>WhatsApp Marketing</h1>
          <p className="hero-description">
            Connect with customers on WhatsApp, the world’s most popular
            messaging app.
          </p>
        </div>
        <div className="hero-background">
          <div className="circle-navy"></div>
          <div className="circle-light-blue"></div>
          <div className="circle-peach"></div>
        </div>
      </section>

      {/* Offer Section */}
      <section className="offer-section">
        <div className="offer-container">
          <div className="offer-image">
            <img
              src="/images/whatsapp2.jpg"
              alt="Phone showing WhatsApp business messages"
            />
          </div>

          <div className="offer-content">
            <h2>Higher Engagement. Greater Reach.</h2>
            <p>
              Our WhatsApp Business Messaging platform lets you send bulks
              WhatsApp messages for every stage of the customer journey simply
              and reliably.
            </p>
            <p style={{ marginBottom: "20px" }}>
              Use rich media like images and videos to run promotions, offer
              support, deliver notifications, and share reminders at scale.
            </p>

            <a
              href="https://app.peakmobile.co.ke/signin"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="sign-up-button">Get Started →</button>
            </a>
          </div>
        </div>
      </section>

      {/* Platform Section */}
      <section className="platform-section-data">
        <h2>Key Features</h2>
        <p className="platform-subtitle-data">
          Our WhatsApp Business Messaging platform is built to help businesses
          engage customers more effectively with speed, scale, and simplicity.
        </p>

        <div className="features-grid-data">
          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/demo.svg" alt="Rich media messaging" />
            </div>
            <h3>Rich Media Messaging</h3>
            <p>
              Engage customers with images, videos, and documents—all in one
              conversation.
            </p>
          </div>

          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/phone-call.svg" alt="Two-way conversations" />
            </div>
            <h3>Two-Way Conversations</h3>
            <p>
              Have real-time chats with customers to build trust and deliver
              better experiences.
            </p>
          </div>

          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/control.svg" alt="Seamless integrations" />
            </div>
            <h3>Seamless Integrations</h3>
            <p>
              Connect effortlessly with your CRM and existing business systems.
            </p>
          </div>

          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/roi-icon.svg" alt="Easy to use" />
            </div>
            <h3>Easy to Use</h3>
            <p>
              Intuitive, user-friendly interface with fast template approvals.
            </p>
          </div>

          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/value.svg" alt="Real-time reports" />
            </div>
            <h3>Real-Time Reports</h3>
            <p>
              Monitor message delivery, performance, and analytics instantly.
            </p>
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="use-cases-section">
        <h2>Industry Use Cases</h2>

        <div className="use-cases-container">
          <div className="industry-selector">
            {industries.map((industry) => (
              <div
                key={industry.id}
                className={`industry-option ${
                  industry.label === activeIndustry ? "active" : ""
                }`}
                onClick={() => setActiveIndustry(industry.label)}
              >
                <div className="industry-name">{industry.label}</div>
                {industry.label === activeIndustry && (
                  <div className="industry-description">
                    {industry.description}
                  </div>
                )}
                <div className="arrow-icon">›</div>
              </div>
            ))}
          </div>

          <div className="use-case-image">
            <img
              src="/images/whatsapp1.jpg"
              alt="WhatsApp marketing use cases"
            />
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="faqs-section">
        <h2>FAQs</h2>

        <div className="faqs-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div
                className="faq-question"
                onClick={() => toggleFAQ(faq.question)}
              >
                <span>{faq.question}</span>
                <span
                  className={`faq-arrow ${
                    expandedFAQ === faq.question ? "expanded" : ""
                  }`}
                >
                  ▼
                </span>
              </div>

              {expandedFAQ === faq.question && (
                <div className="faq-answer">
                  {typeof faq.answer === "string" ? (
                    <p>{faq.answer}</p>
                  ) : (
                    faq.answer
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default WhatsAppMarketingPage;